
// src/components/UI/Modal.js
import React from 'react';
import { Modal as BootstrapModal, Button } from 'react-bootstrap';

export const Modal = ({ isOpen, onClose, title, children, size = 'lg' }) => {
    return (
        <BootstrapModal
            show={isOpen}
            onHide={onClose}
            centered
            size={size}
            className="fade-in"
        >
            <BootstrapModal.Header closeButton>
                <BootstrapModal.Title>{title}</BootstrapModal.Title>
            </BootstrapModal.Header>
            <BootstrapModal.Body>
                {children}
            </BootstrapModal.Body>
        </BootstrapModal>
    );
};

export const ConfirmModal = ({ isOpen, onClose, onConfirm, title, message, confirmText = 'Potvrdit', cancelText = 'Zrušit', variant = 'danger' }) => {
    return (
        <BootstrapModal
            show={isOpen}
            onHide={onClose}
            centered
            className="fade-in"
        >
            <BootstrapModal.Header closeButton>
                <BootstrapModal.Title>{title}</BootstrapModal.Title>
            </BootstrapModal.Header>
            <BootstrapModal.Body>
                {message}
            </BootstrapModal.Body>
            <BootstrapModal.Footer>
                <Button variant="secondary" onClick={onClose}>
                    {cancelText}
                </Button>
                <Button variant={variant} onClick={onConfirm}>
                    {confirmText}
                </Button>
            </BootstrapModal.Footer>
        </BootstrapModal>
    );
};
